import { Filter } from '@sketch/components'
import { useTreeSearch } from './useTreeSearch'
import React from 'react'
import styled from 'styled-components'

const StyledFilter = styled(Filter)`
  margin-bottom: 8px;
`

export const TreeSearchFilter = () => {
  const { onSearchChange, search } = useTreeSearch()

  return (
    <StyledFilter
      fullWidth
      value={search.name || ''}
      onChange={value => onSearchChange({ name: value })}
      onSubmit={() => onSearchChange(search, true)}
      placeholder="Search…"
      onClear={() => onSearchChange({ name: '' }, true)}
    />
  )
}
